import { LEGAL_VERSIONS } from "@/config/legalVersions";

// Lokaler Consent-Nachweis (Fallback), solange der serverseitige Consent-Contract
// (siehe README/Report: fehlender Backend-Endpunkt) noch nicht steht. Speichert NUR
// Version + Zeitpunkt + Provider – niemals vollständige Rechtstexte.
const consentKey = (user) =>
  `voyalyo_consent_${user?.id || user?._id || user?.uid || user?.email || "anon"}`;

// True, wenn für die AKTUELLEN Versionsstände bereits eine Zustimmung vorliegt –
// entweder vom Backend geliefert (terms_version/privacy_version) oder lokal protokolliert.
export function hasRecordedConsent(user) {
  if (!user) return false;
  if (
    user.terms_version === LEGAL_VERSIONS.terms &&
    user.privacy_version === LEGAL_VERSIONS.privacy
  ) {
    return true;
  }
  try {
    const raw = localStorage.getItem(consentKey(user));
    if (!raw) return false;
    const rec = JSON.parse(raw);
    return (
      rec.terms_version === LEGAL_VERSIONS.terms &&
      rec.privacy_version === LEGAL_VERSIONS.privacy
    );
  } catch {
    return false;
  }
}

// Schreibt den lokalen Nachweis (Version + Zeitpunkt + Provider).
export function recordLocalConsent(user, provider) {
  const now = new Date().toISOString();
  const rec = {
    terms_accepted: true,
    privacy_acknowledged: true,
    terms_version: LEGAL_VERSIONS.terms,
    privacy_version: LEGAL_VERSIONS.privacy,
    terms_accepted_at: now,
    privacy_acknowledged_at: now,
    registration_provider: provider,
  };
  try {
    localStorage.setItem(consentKey(user), JSON.stringify(rec));
  } catch {
    // Storage nicht verfügbar – Flow trotzdem nicht blockieren.
  }
  return rec;
}
